import apiClient from "../../../api/apiClient";

// ================= GET ALL =================
export const getRepairQuotationsApi =
  async (
    page: number,
    pageSize: number,
    search: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        "/repair-quotations",
        {
          params: {
            pageNumber: page,
            pageSize,
            search,
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= GET BY ID =================
export const getRepairQuotationByIdApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        `/repair-quotations/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= CREATE =================
export const createRepairQuotationApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.post(
        "/repair-quotations",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= UPDATE =================
export const updateRepairQuotationApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.put(
        "/repair-quotations",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= DELETE =================
export const deleteRepairQuotationApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.delete(
        `/repair-quotations/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };